import { useParams, useSearchParams } from 'react-router-dom';
import { MonthParams } from '../../types';

export function useRouteParams() {
  const { year, month } = useParams<MonthParams>();

  const [searchParams] = useSearchParams();
  const datum = searchParams.get('datum') || '';

  return {
    routeParams: {
      jahr: parseInt(year),
      monat: parseInt(month),
    },
    searchParams: { datum },
  };
}
